import { useLanguage } from "@/context/LanguageContext";

/** İki dilli segmented control — aktif olan vurgulu, tıklanabilir olan diğer dil.
 * Örn: [ TR | en ]  → TR seçili, EN'e tıklanabilir. */
export default function LanguageToggle() {
  const { locale, setLocale } = useLanguage();

  const opts = [
    { code: "tr", label: "TR", flag: "🇹🇷", aria: "Türkçe" },
    { code: "en", label: "EN", flag: "🇬🇧", aria: "English" },
  ];

  return (
    <div
      role="group"
      aria-label="Dil seçimi / Language selection"
      className="inline-flex items-center rounded-full border border-border/50 bg-background/80 p-0.5 backdrop-blur-sm"
      data-testid="lang-toggle"
    >
      {opts.map(o => {
        const active = locale === o.code;
        return (
          <button
            key={o.code}
            onClick={() => setLocale(o.code)}
            aria-pressed={active}
            aria-label={o.aria}
            className={
              "inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold transition-all duration-150 " +
              (active
                ? "bg-primary text-primary-foreground shadow-sm cursor-default"
                : "text-muted-foreground hover:text-foreground hover:bg-muted/60")
            }
            data-testid={`lang-opt-${o.code}`}
          >
            <span aria-hidden="true">{o.flag}</span>
            <span>{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
